const tickets = {
  title: 'Edit ticket',
  add_title: 'Add ticket',
  event: 'Event',
  status: 'Status',
  ticket_identifier: 'Ticket Number',
  contact: 'Contact',
  seller: 'Seller',
  first_name: 'First Name',
  last_name: 'Last Name',
  email: 'Email',
  phone: 'Phone',
  sold_price: 'Sold Price',
  send_title: 'Send tickets',
  send_to: 'Send to',
  all: 'All',
  selected: 'Selected',
  send_by: 'Send by',
  sms: 'SMS',
  message: 'Message',
  download_title: 'Download tickets',
  download_to: 'Download',
  export_title: 'Export tickets',
  export_to: 'Export',
  format: 'Format',
  delivery: 'Delivery',
  by_email: 'By email',
};

export default tickets;
